<template>
  <v-container fluid>
    <v-card class="mt-7" flat>
      <v-card-title class="justify-center" style="word-break:break-word">{{panelTitle}}</v-card-title>
      <ent-select
        :label="selectLabel"
        :config="singleSelectSettings"
        :choices="selectionChoices"
        v-model="selection"
      />
    </v-card>
  </v-container>
</template>
<script>
  import { sync } from "vuex-pathify";
  import phraseProc from "@/../../library/helper/phrase.js";
  import check from "@/../../library/helper/propertyCheck.js";
  import EntSelect from "@/../../library/view/EntSelect.vue";

  export default {
    components: { EntSelect },
    props: ["args"],
    data: () => ({
      singleSelectSettings: { multiple: false, label: true, chips: false },
      selection: null,
      selectionChoices: null,
    }),
    computed: {
      dark: sync("misc/dark"),
      userlang: sync("misc/language"),
      phrases: sync("misc/phraseMap"),
      panelTitle() {
        return this.getPhrase(this.args.panelTitle)
      },
      selectLabel() {
        return this.getPhrase(this.args.selectLabel)
      }
    },
    watch: {
      selection() {
        this.processSelection()
      }
    },
    methods: {
      getPhrase(item) {
        return phraseProc.mapPhrase(item, this.phrases, this.userlang)
      },
      processSelection() {
        this.$emit("update:selection", this.selection)
      }
    },
    async created() {
      const records = await this.args.cb();
      let choiceArray = [];
      for (const entry of records) {
        let choice = { id: entry["_id"], name: entry[this.args.cb_name] };
        choiceArray.push(choice);
      }
      this.selectionChoices = choiceArray;
    },
  };
</script>
